import auth from '@/router/middleware/auth';

const ReportModule = r => require.ensure([], () => r(require('./index')), 'report-module-qlik-cloud-bundle');
const printReport= r =>require.ensure([], () => r(require('./printReport')), 'report-module-qlik-print-bundle');
export default [
  {
    path: '/report-module-qlik-cloud',
    name: 'report-module-qlik-cloud',
    component: ReportModule,
    meta: {
      middleware: [auth]
    },
    children:[
      
    ]
  },
  {
    path: '/printQlikReport/:appID/:sheetID',
    name: 'printQlikReport',
    component: printReport,
    meta: {
      middleware: [auth]
    },
  }
];
